<template>
  <div>
    <PendingUserForms v-if="pendingForms.length" :title="$t('table.pendingForms')" :items="pendingForms" />
    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item to="/my-forms/dataset/newDataset">
            <v-list-item-icon><v-icon>mdi-plus</v-icon></v-list-item-icon>
            {{ $t("dataset.forms.newDataset") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="datasets"
      :search="search"
      :loading="loading"
      :items-per-page="30"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      class="elevation-1 table-cursor-hand mt-4"
      sort-by="publication_date"
      sort-desc
      @click:row="openDataset"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details />
        </v-toolbar>
      </template>
      <template v-slot:item.access_type="{ item }">
        {{ $t(`form.dataset_access_types.${item.access_type}`) }}
      </template>
      <template v-slot:item.licenses="{ item }">
        {{ licenseNames(item.licenses) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "@/components/forms/PendingUserForms";

export default {
  name: "ListDatasets",
  components: { PendingUserForms },
  data: () => ({ loading: true, search: "", datasets: [], licenses: [], pendingForms: [] }),
  computed: {
    headers() {
      return [
        { text: this.$t("form.dataset_title"), value: "title" },
        { text: this.$t("form.dataset_access_type"), value: "access_type" },
        { text: this.$t("form.dataset_licenses"), value: "licenses" },
        { text: this.$t("form.dataset_publication_date"), value: "publication_date" }
      ];
    }
  },
  created() {
    Promise.all([
      axios.get(`${this.$store.state.endpoint}/user/dataset`),
      axios.get(`${this.$store.state.endpoint}/dataset/licenses`),
      axios.get(`${this.$store.state.endpoint}/user/moderatedOperations/pending/dataset`)
    ]).then(([datasets, licenses, forms]) => {
      this.datasets = datasets.data;
      this.licenses = licenses.data;
      this.pendingForms = forms.data;
    }).catch(error => console.error(error)).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    licenseNames(ids) {
      return (ids || []).map(id => {
        const license = this.licenses.find(item => String(item.value) === String(id));
        return license ? license.label : "";
      }).filter(Boolean).join(", ");
    },
    openDataset(item) {
      this.$router.push(`/datasets/${item.id}`);
    }
  }
};
</script>
